import React, { PureComponent } from 'react';
import { Modal } from 'antd';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { push } from "connected-react-router";
import { connect } from 'react-redux';

import { toggleConfirmationModal } from './confirmationModalActions';
import { withActions } from 'actionware';
import ConfirmModalContent from './confirmModalContent';
import SaveModalContent from './saveModalContent';
import ErrorModalContent from './errorModalContent';

import { modalPopupStates } from '../../common/constants';
import { persistNewCycleData, persistEditCurrentCycleData } from '../fundingLimit/fundingLimitActions';
import { persistEditLenderRankMapperData, persistNewCycleMapperData } from '../fundingLimit/fundingLimitComponents/utils';
import {fetchLenderPreferences, persistNewPreferenceData} from '../approvalSetting/approvalSettingActions'

@connect(({ localize,
    newCycle, 
    newPreference,
    confirmation: { showingConfirmationModal, action }}) => ({
    translate: getTranslate(localize),
    showingConfirmationModal,
    loading: action === modalPopupStates.submitting,
    action
}))
@withActions({
    toggleConfirmationModal,
    persistNewCycleData,
    persistEditCurrentCycleData,
    fetchLenderPreferences,
    persistNewPreferenceData,
})
class ConfirmationModal extends PureComponent {
    
    constructor() {
        super();
        this.state = {
            loading: false
        }
        this.confirmAllocation = this.confirmAllocation.bind(this)
        this.editCurrentCycle = this.editCurrentCycle.bind(this)
        this.confirmAutoApproval = this.confirmAutoApproval.bind(this)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.showingConfirmationModal && !this.props.showingConfirmationModal) {
        }
    }

    confirmAllocation() {
        const { newCycle } = this.props
        const payload = persistNewCycleMapperData(newCycle);
        this.props.persistNewCycleData(payload);
        this.setState({
            loading: true
        })
    }

    confirmAutoApproval() {
        const { newPreference } = this.props
        this.props.persistNewPreferenceData(newPreference)
        this.setState({
            loading: true
        })
    }

    retryAllocation() {
        this.setState({
            loading: true
        })
    }

    editCurrentCycle() {
        const { newCycle, persistEditCurrentCycleData } = this.props
        const payload = persistEditLenderRankMapperData(newCycle);
        persistEditCurrentCycleData(payload);
        this.setState({
            loading: true
        })
    }
    renderModalContent = () => {
        const {action, toggleConfirmationModal, newPreference} = this.props;
        const confirmAutoApprovalModalTitle = newPreference.auto_approval_enabled ? 'confirmationModal.lender_admin_heading_turnon_auto_approval' : 'confirmationModal.lender_admin_heading_turnoff_auto_approval';
        const confirmAutoApprovalModalSubTitle = newPreference.auto_approval_enabled ? 'confirmationModal.lender_admin_body_turnon_auto_approval' : 'confirmationModal.lender_admin_body_turnoff_auto_approval';
        const modalContent = {
            [modalPopupStates.confirmAllocation]: <ConfirmModalContent onOk={this.confirmAllocation} onCancel={toggleConfirmationModal} title={'confirmationModal.ovo_admin_heading_confirm_lender_allocation'} subtitle={'confirmationModal.ovo_admin_body_confirm_lender_allocation'}/>,
            [modalPopupStates.errorOccurred]: <ErrorModalContent onOk={this.retryAllocation} onCancel={toggleConfirmationModal} />,
            [modalPopupStates.editCurrentCycle]: <ConfirmModalContent onOk={this.editCurrentCycle} onCancel={toggleConfirmationModal} title={'confirmationModal.ovo_admin_heading_confirm_unsaved_changes'} subtitle={'confirmationModal.ovo_admin_body_confirm_unsaved_changes'}/>,
            [modalPopupStates.autoApproval]: <ConfirmModalContent onOk={this.confirmAutoApproval} onCancel={toggleConfirmationModal} title={confirmAutoApprovalModalTitle} subtitle={confirmAutoApprovalModalSubTitle}/>,
        }
        return modalContent[action] ? modalContent[action] : <></>;
    }

    render() {

        const {
        showingConfirmationModal,
        toggleConfirmationModal,
        } = this.props
        return (
        <Modal
            className={'modal-form'}
            wrapClassName='modal-form'
            visible={showingConfirmationModal}
            onCancel={toggleConfirmationModal}
            okType='primary'
            closeIcon={false}
            confirmLoading={this.state.loading}
            width={630}
        >
            {this.renderModalContent()}
        </Modal>
        );
  }
}


const mapStateToProps = ({
    localize,
    funding: { newCycle },
    autoApproval: { newPreference },
  }) => ({
    translate: getTranslate(localize),
    newCycle,
    newPreference,
  });
  
  const mapDispatchToProps = (dispatch) => bindActionCreators({ push }, dispatch);
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withActions({ persistNewCycleData, fetchLenderPreferences, persistNewPreferenceData })(ConfirmationModal));
